module.exports = __webpack_public_path__ + "img/relazione.2f8faf16.jpg";